export const DRILLBOARD_WORKER_URL = 'https://drillboards-worker.windy852456.workers.dev/'
